import { defineComponent as y, inject as C, ref as v, computed as d, h as a } from "vue";
import { shouldUseArrayInSingleMode as m } from "./ghl-ui.es1307.js";
import { dataTableInjectionKey as b } from "./ghl-ui.es949.js";
import g from "./ghl-ui.es985.js";
import k from "./ghl-ui.es931.js";
import A from "./ghl-ui.es243.js";
import x from "./ghl-ui.es163.js";
import V from "./ghl-ui.es162.js";
import s from "./ghl-ui.es223.js";
const S = y({
  name: "DataTableFilterMenu",
  props: {
    column: {
      type: Object,
      required: !0
    },
    radioGroupName: {
      type: String,
      required: !0
    },
    multiple: {
      type: Boolean,
      required: !0
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    onConfirm: {
      type: Function,
      required: !0
    },
    onClear: {
      type: Function,
      required: !0
    },
    onChange: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedClsPrefixRef: i,
      mergedThemeRef: u,
      localeRef: n
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = C(b), l = v(e.value), t = d(() => {
      const { value: r } = l;
      return Array.isArray(r) ? r : null;
    }), c = d(() => {
      const { value: r } = l;
      return m(e.column) ? Array.isArray(r) && r.length && r[0] || null : Array.isArray(r) ? null : r;
    });
    function o(r) {
      e.onChange(r);
    }
    function f(r) {
      e.multiple && Array.isArray(r) ? l.value = r : m(e.column) && !Array.isArray(r) ? l.value = [r] : l.value = r;
    }
    function h() {
      o(l.value), e.onConfirm();
    }
    function p() {
      e.multiple || m(e.column) ? o([]) : o(null), e.onClear();
    }
    return {
      mergedClsPrefix: i,
      mergedTheme: u,
      locale: n,
      checkboxGroupValue: t,
      radioGroupValue: c,
      handleChange: f,
      handleConfirmClick: h,
      handleClearClick: p
    };
  },
  render() {
    const { mergedTheme: e, locale: i, mergedClsPrefix: u } = this;
    return a(
      "div",
      { class: `${u}-data-table-filter-menu` },
      a(g, null, {
        default: () => {
          const { checkboxGroupValue: n, handleChange: l } = this;
          return this.multiple ? a(k, { value: n, class: `${u}-data-table-filter-menu__group`, onUpdateValue: l }, {
            default: () => this.options.map((t) => a(A, { key: t.value, theme: e.peers.Checkbox, themeOverrides: e.peerOverrides.Checkbox, value: t.value }, { default: () => t.label }))
          }) : a(x, { name: this.radioGroupName, class: `${u}-data-table-filter-menu__group`, value: this.radioGroupValue, onUpdateValue: this.handleChange }, {
            default: () => this.options.map((t) => a(V, { key: t.value, value: t.value, theme: e.peers.Radio, themeOverrides: e.peerOverrides.Radio }, { default: () => t.label }))
          });
        }
      }),
      a(
        "div",
        { class: `${u}-data-table-filter-menu__action` },
        a(s, { size: "tiny", theme: e.peers.Button, themeOverrides: e.peerOverrides.Button, onClick: this.handleClearClick }, { default: () => i.clear }),
        a(s, { theme: e.peers.Button, themeOverrides: e.peerOverrides.Button, type: "primary", size: "tiny", onClick: this.handleConfirmClick }, { default: () => i.confirm })
      )
    );
  }
});
export {
  S as default
};
